// TAMS models
export var AccountState;
(function (AccountState) {
    AccountState["Initiated"] = "INITIATED";
    AccountState["Requested"] = "REQUESTED";
    AccountState["Active"] = "ACTIVE";
    AccountState["ClosingInProgress"] = "CLOSING_IN_PROGRESS";
    AccountState["Closed"] = "CLOSED";
    AccountState["Suspended"] = "SUSPENDED";
})(AccountState || (AccountState = {}));
//# sourceMappingURL=transaction-account.js.map